"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentRuleStatus = void 0;
var RentRuleStatus;
(function (RentRuleStatus) {
    RentRuleStatus["NEW"] = "NEW";
    RentRuleStatus["ACTIVE"] = "ACTIVE";
    RentRuleStatus["INACTIVE"] = "INACTIVE";
})(RentRuleStatus || (exports.RentRuleStatus = RentRuleStatus = {}));
//# sourceMappingURL=rent.js.map